import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Typography } from "@mui/material";
import { SimpleForm, TextInput, SelectInput, ReferenceInput, Create, FormDataConsumer, } from "react-admin";
import { JsonInput } from "react-admin-json-view";
export var CreateBallotStyle = function () {
    return (_jsx(Create, { children: _jsxs(SimpleForm, { children: [_jsx(Typography, { variant: "h4", children: "Ballot Style" }), _jsx(Typography, { variant: "body2", children: "Ballot Style creation" }), _jsx(TextInput, { source: "ballot_eml" }), _jsx(TextInput, { source: "status" }), _jsx(ReferenceInput, { source: "tenant_id", reference: "sequent_backend_tenant", children: _jsx(SelectInput, { optionText: "username" }) }), _jsx(FormDataConsumer, { children: function (_a) {
                        var formData = _a.formData;
                        return (_jsxs(_Fragment, { children: [_jsx(ReferenceInput, { source: "election_event_id", reference: "sequent_backend_election_event", filter: { tenant_id: formData.tenant_id }, children: _jsx(SelectInput, { optionText: "name" }) }), _jsx(ReferenceInput, { source: "election_id", reference: "sequent_backend_election", filter: {
                                        tenant_id: formData.tenant_id,
                                        election_event_id: formData.election_event_id,
                                    }, children: _jsx(SelectInput, { optionText: "name" }) }), _jsx(ReferenceInput, { source: "area_id", reference: "sequent_backend_area", filter: {
                                        tenant_id: formData.tenant_id,
                                        election_event_id: formData.election_event_id,
                                    }, children: _jsx(SelectInput, { optionText: "name" }) })] }));
                    } }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } }), _jsx(JsonInput, { source: "annotations", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } }), _jsx(JsonInput, { source: "status", jsonString: false, reactJsonOptions: {
                        name: null,
                        collapsed: true,
                        enableClipboard: true,
                        displayDataTypes: false,
                    } })] }) }));
};
